@if (selectedRequest()) {
    <div>
        <!-- Stepper visual horizontal flotante sin panel blanco -->
        @if (!isEditingDetail()) {
            <div class="mb-3 mt-1 mt-md-2 mb-md-4">
                <app-timeline
                    [steps]="timelineSteps()"
                    [currentStep]="currentStep()"
                    [allowAllSteps]="true"
                    (stepChange)="currentStep.set($event)">
                </app-timeline>
            </div>
        }

        <div class="panel mb-4"
             [class.panel-claim-mobile]="appSettings.isMobile() && currentStepObj()?.title === 'Siniestro' && !isEditingDetail()"
             [class.panel-detail-open]="isEditingDetail()">
            @if (!isEditingDetail() && !appSettings.isMobile()) {
                <div class="step-header d-flex align-items-center justify-content-between gap-3">
                    <h5 class="mb-0 text-dark fw-bold text-nowrap">
                        @switch (currentStepObj()?.title) {
                            @case ('Socio') {
                                <i class="fas fa-user me-2 text-primary"></i>Datos del Socio
                            }
                            @case ('Afectado') {
                                <i class="fas fa-user-injured me-2 text-warning"></i>Información del Tercero Afectado
                            }
                            @case ('Siniestro') {
                                <i class="fas fa-car-burst me-2 text-primary"></i>Siniestro{{ claimTypeLabel() ? ' - ' + claimTypeLabel() : '' }}
                            }
                            @case ('Aprobación') {
                                <i class="fas fa-gavel me-2 text-primary"></i>Aprobación de la Solicitud
                            }
                        }
                    </h5>
                    <app-flow-badge
                        display="badge"
                        [processSlug]="selectedRequest()?.processSlug"
                        [statusSlug]="selectedRequest()?.statusSlug">
                    </app-flow-badge>
                </div>
            }

            <!-- Paso: Socio -->
            @if (currentStepObj()?.title === 'Socio') {
                <div class="step-body">
                    <app-party-form [partyForm]="partyForm" [mode]="formMode.VIEW"></app-party-form>
                </div>
            }

            <!-- Paso: Afectado (Solo Terceros en Siniestros) -->
            @if (currentStepObj()?.title === 'Afectado') {
                <div class="step-body">
                    <app-third-party-form
                        [thirdPartyData]="selectedRequest()?.claim?.thirdPartyInfo"
                        [mode]="formMode.VIEW">
                    </app-third-party-form>
                </div>
            }

            <!-- Paso: Siniestro -->
            @if (currentStepObj()?.title === 'Siniestro') {
                <div class="step-body">
                    <app-claim-details-manager
                        [claimData]="selectedRequest()?.claim"
                        [partyData]="selectedRequest()?.party"
                        [mode]="formMode.VIEW"
                        [canEditDetails]="canReviewContent()"
                        [canFinalApproveDocs]="canFinalContentReview()"
                        [canEditNegligence]="canApprove()"
                        [canReplaceObserved]="canReplaceObserved()"
                        [(isEditingDetail)]="isEditingDetail"
                        [(claimDetails)]="claimDetails"
                        (documentUploaded)="loadRequests()">
                    </app-claim-details-manager>
                </div>
            }

            <!-- Paso: Aprobación — ruta BPM + informe (split como confirm-request) -->
            @if (currentStepObj()?.title === 'Aprobación') {
                <div class="step-body">
                    <div class="approval-grid">
                        <div class="approval-grid__summary">
                            <app-flow-steps
                                [request]="selectedRequest()"
                                layout="timeline"
                                (viewDocument)="openVotoDocument()">
                            </app-flow-steps>

                            <div class="approval-grid__pdf-toggle">
                                <button type="button" class="btn btn-outline-primary w-100" (click)="openClaimInforme()">
                                    <i class="fas fa-file-pdf me-2"></i> Ver informe
                                </button>
                            </div>
                        </div>
                        <div class="approval-grid__pdf">
                            <div class="approval-pdf">
                                <app-claim-informe-pdf #claimInforme [inline]="true"></app-claim-informe-pdf>
                            </div>
                        </div>
                    </div>
                </div>
            }

            @if (!isEditingDetail() && currentStepObj()?.title === 'Aprobación' && !appSettings.isMobile()) {
                <div class="step-footer step-footer--approval">
                    <button type="button" class="btn btn-outline-secondary btn-sm px-3" (click)="prevStep()">
                        <i class="fas fa-arrow-left me-2"></i> Anterior
                    </button>
                    <app-bpm
                        class="step-footer__bpm"
                        [request]="selectedRequest()"
                        [isProcessing]="isProcessingApproval()"
                        [blockedReason]="bpmBlockedReason()"
                        (approve)="approveRequest()"
                        (reject)="rejectRequest()"
                        (confirmed)="onStepApprovalConfirmed($event)">
                    </app-bpm>
                </div>
            } @else if (!isEditingDetail() && !appSettings.isMobile()) {
                <div class="step-footer">
                    <button class="btn btn-outline-secondary btn-sm px-3" (click)="prevStep()" [disabled]="currentStep() === 1">
                        <i class="fas fa-arrow-left me-2"></i> Anterior
                    </button>
                    <button class="btn btn-primary btn-sm px-3" (click)="nextStep()" [disabled]="currentStep() === timelineSteps().length">
                        Siguiente <i class="fas fa-arrow-right ms-2"></i>
                    </button>
                </div>
            }
        </div>
    </div>
}

@if (appSettings.isMobile() && currentStepObj()?.title === 'Aprobación' && !isEditingDetail()) {
    <div class="bpm-mobile-host" aria-hidden="true">
        <app-bpm
            [request]="selectedRequest()"
            [isProcessing]="isProcessingApproval()"
            [blockedReason]="bpmBlockedReason()"
            [hideButtons]="true"
            (approve)="approveRequest()"
            (reject)="rejectRequest()"
            (confirmed)="onStepApprovalConfirmed($event)">
        </app-bpm>
    </div>

    <app-mobile-footer [visible]="showApprovalMobileFooter()">
        @if (canApprove()) {
            <button type="button"
                class="btn btn-outline-danger btn-sm"
                [disabled]="isProcessingApproval()"
                (click)="onMobileReject()">
                <i class="fas fa-times me-1"></i>Rechazar
            </button>
            <span class="d-inline-flex flex-grow-1" [attr.title]="bpmBlockedReason() || null">
                <button type="button"
                    class="btn btn-success btn-sm w-100"
                    [disabled]="!canConfirmApproval() || isProcessingApproval()"
                    (click)="onMobileApprove()">
                    @if (isProcessingApproval()) {
                        <span class="spinner-border spinner-border-sm me-1"></span>
                    }
                    <i class="fas fa-check-circle me-1"></i>{{ approveMobileLabel() }}
                </button>
            </span>
        }
    </app-mobile-footer>
}

@if (isViewerOpen()) {
    <app-viewer
        title="Documento del paso"
        [items]="viewerItems()"
        [activeId]="activeDocId()"
        [allowDelete]="false"
        (onSelect)="activeDocId.set($event)"
        (close)="isViewerOpen.set(false)">
    </app-viewer>
}